
import { db, auth } from "app/firebaseInit";
import { addDoc, collection, doc, getDocs, query, serverTimestamp, setDoc, updateDoc, where } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL, getStorage, deleteObject, uploadBytesResumable } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";
import { CATEGORY_IMAGE_BASE_DIRECTORY, EDITOR_IMAGE_BASE_DIRECTORY, IMAGE_BASE_DIRECTORY, ONBOARDING_IMAGE_BASE_DIRECTORY, PODCAST_BASE_DIRECTORY, UPLOADS_ARCHIVED_STATUS, UPLOADS_CATEGORY_SOURCE, UPLOADS_COLLECTION_NAME, UPLOADS_COMPLETED_STATUS, UPLOADS_CONTENT_COVER_SOURCE, UPLOADS_CONTENT_EDITOR_SOURCE, UPLOADS_CONTENT_PODCAST_SOURCE, UPLOADS_CONTENT_PODCAST_TYPE, UPLOADS_CONTENT_VIDEO_SOURCE, UPLOADS_CONTENT_VIDEO_TYPE, UPLOADS_IMAGE_TYPE, UPLOADS_INPROGRESS_STATUS, UPLOADS_ONBOARDING_SOURCE, UPLOADS_UPLOADED_STATUS, VIDEO_BASE_DIRECTORY } from "./constant";

const storage = getStorage();

export const uploadFileFromStorage = async (file, directory) => {
    const storageRef = ref(storage, `${directory}/${uuidv4()}_${file.name}`);
    await uploadBytes(storageRef, file);
    return await getDownloadURL(storageRef);
};

export const deleteFileFromStorage = async (fileUrl) => {
    if (fileUrl) {
        const fileRef = ref(storage, fileUrl);
        await deleteObject(fileRef);
    }
};

export async function uploadWithTrackingForContentEditor(file, { sourceId = null }) {
    return await uploadWithTrackingForImages(file, { source: UPLOADS_CONTENT_EDITOR_SOURCE, sourceId, basePath: EDITOR_IMAGE_BASE_DIRECTORY });
}

export async function uploadWithTrackingForContentCover(file, { sourceId = null }) {
    return await uploadWithTrackingForImages(file, { source: UPLOADS_CONTENT_COVER_SOURCE, sourceId, basePath: "" });
}

export async function uploadWithTrackingForContentCategory(file, { sourceId = null }) {
    return await uploadWithTrackingForImages(file, { source: UPLOADS_CATEGORY_SOURCE, sourceId, basePath: CATEGORY_IMAGE_BASE_DIRECTORY });
}

export async function uploadWithTrackingForContentOnboarding(file, { sourceId = null }) {
    return await uploadWithTrackingForImages(file, { source: UPLOADS_ONBOARDING_SOURCE, sourceId, basePath: ONBOARDING_IMAGE_BASE_DIRECTORY });
}
/**
 * Dosya yükleme lifecycle
 */
async function uploadWithTrackingForImages(file, { source, sourceId = null, basePath = "" }) {
    // 1. Upload kaydı oluştur
    const user = auth.currentUser;
    const userId = user?.uid || null;

    const fileName = `${Date.now()}_${file.name}`;
    const path = `${basePath !== "" ? `${IMAGE_BASE_DIRECTORY}/${basePath}` : `${IMAGE_BASE_DIRECTORY}`}/${fileName}`;
    const storageRef = ref(storage, path);

    //image ler imgix ten yüklendiği için pathler firestore a inünde images olmadan kaydediliyor.
    const pathToSave = `${basePath !== "" ? `${basePath}/` : ""}${fileName}`;

    // const uploadRef_ = doc(db, UPLOADS_COLLECTION_NAME, crypto.randomUUID());
    // await setDoc(uploadRef_, {
    //     type: "image",
    //     source,
    //     sourceId,
    //     status: UPLOADS_INPROGRESS_STATUS,
    //     path,
    //     userId,
    //     createdAt: serverTimestamp(),
    //     updatedAt: serverTimestamp()
    // });

    const uploadRef = await addDoc(collection(db, UPLOADS_COLLECTION_NAME), {
        type: "image",
        source,
        sourceId,
        status: UPLOADS_INPROGRESS_STATUS,
        path,
        userId,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
    });

    // 2. Upload başlat
    const task = uploadBytesResumable(storageRef, file);

    return new Promise((resolve, reject) => {
        task.on(
            "state_changed",
            null,
            async (error) => {
                await updateDoc(uploadRef, {
                    status: "error",
                    errorMessage: error.message,
                    updatedAt: serverTimestamp()
                });
                reject(error);
            },
            async () => {
                // 3. Upload bitti → uploaded state
                await updateDoc(uploadRef, {
                    path,
                    status: UPLOADS_UPLOADED_STATUS,
                    updatedAt: serverTimestamp()
                });
                resolve({ uploadId: uploadRef.id, uploadRef: uploadRef, path: pathToSave });
            }
        );
    });
}

export async function uploadWithTrackingPodcast(file, sourceId = null) {
    return await uploadWithTrackingMedia(file, { type: UPLOADS_CONTENT_PODCAST_TYPE, source: UPLOADS_CONTENT_PODCAST_SOURCE, sourceId, directory: PODCAST_BASE_DIRECTORY });
}

export async function uploadWithTrackingVideo(file, sourceId = null) {
    return await uploadWithTrackingMedia(file, { type: UPLOADS_CONTENT_VIDEO_TYPE, source: UPLOADS_CONTENT_VIDEO_SOURCE, sourceId, directory: VIDEO_BASE_DIRECTORY });
}

async function uploadWithTrackingMedia(file, { type, source, sourceId = null, directory }) {
    const user = auth.currentUser;
    const userId = user?.uid || null;

    // Storage path hesapla
    const fileName = `${Date.now()}_${file.name}`;
    const path = `${directory}/${fileName}`;

    // const uploadRef_ = doc(db, UPLOADS_COLLECTION_NAME, crypto.randomUUID());
    // await setDoc(uploadRef_, {
    //     type,
    //     source,
    //     sourceId,
    //     status: UPLOADS_INPROGRESS_STATUS,
    //     path,
    //     userId,
    //     createdAt: serverTimestamp(),
    //     updatedAt: serverTimestamp()
    // });

    const uploadRef = await addDoc(collection(db, UPLOADS_COLLECTION_NAME), {
        type,
        source,
        sourceId,
        status: UPLOADS_INPROGRESS_STATUS,
        path,
        userId,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
    });

    const storageRef = ref(storage, path);

    const task = uploadBytesResumable(storageRef, file);

    return { task, uploadRef, path };
}

export async function archiveUploadsBySourceIdForCategory(sourceId) {
    await archiveUploadsBySourceId(UPLOADS_CATEGORY_SOURCE, sourceId);
}

export async function archiveUploadsBySourceIdForOnboarding(sourceId) {
    await archiveUploadsBySourceId(UPLOADS_ONBOARDING_SOURCE, sourceId);
}

/**
 * Belirtilen sourceId'ye ait tüm uploads kayıtlarını "archived" yapar.
 * @param {string} sourceId - Kaynağın ID'si (ör. contentId, categoryId)
 */
async function archiveUploadsBySourceId(source, sourceId) {
    if (!sourceId || !source) return;
    try {
        const uploadsRef = collection(db, UPLOADS_COLLECTION_NAME);
        const q = query(
            uploadsRef,
            where("sourceId", "==", sourceId),
            where("source", "==", source)
        );
        const snapshot = await getDocs(q);
        snapshot.forEach(d => {
            const data = d.data();
            console.log(`doc: ${d.id}, source=[${data.source}]`);
        });

        if (snapshot.empty) return;

        const updates = snapshot.docs.map((docSnap) =>
            updateDoc(docSnap.ref, {
                status: UPLOADS_ARCHIVED_STATUS,
                updatedAt: serverTimestamp()
            })
        );
        await Promise.all(updates);
    } catch (error) {
        console.error("Failed to archive uploads for sourceId:", sourceId, error);
        throw error;
    }
}





export async function createUploadCompletedRecord({ type, source, sourceId, path, userId, status = UPLOADS_COMPLETED_STATUS,
}) {
    return await addDoc(collection(db, UPLOADS_COLLECTION_NAME), {
        type,
        source,
        sourceId,
        path,
        status,
        userId,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
    });
}

async function createMissingUploads() {
    try {
        const contentsRef = collection(db, "contents");
        const contentsSnap = await getDocs(contentsRef);
        let coverImageCount = 0;
        let videoCount = 0;
        let audioCount = 0;
        let editorImageCount = 0;

        for (const contentDoc of contentsSnap.docs) {
            const contentData = contentDoc.data();
            const contentId = contentDoc.id;

            const userId = contentData.createdBy || null;
            const coverImage = contentData.coverImage;

            // 1️⃣ Kapak resmi uploads kaydı
            if (coverImage) {
                const existingCoverQ = query(
                    collection(db, UPLOADS_COLLECTION_NAME),
                    where("sourceId", "==", contentId),
                    where("source", "==", UPLOADS_CONTENT_COVER_SOURCE)
                );
                const existingCoverSnap = await getDocs(existingCoverQ);

                if (existingCoverSnap.empty) {
                    await createUploadCompletedRecord({
                        type: UPLOADS_IMAGE_TYPE,
                        source: UPLOADS_CONTENT_COVER_SOURCE,
                        sourceId: contentId,
                        path: `${IMAGE_BASE_DIRECTORY}/${coverImage}`,
                        userId: userId
                    })
                    coverImageCount++;
                    console.log(`Cover upload added for content ${contentId} image: images${coverImage}`);
                }
            }

            // 2️⃣ ContentDetails üzerinden mediaUrl ve editor image
            const contentDetailsQ = query(
                collection(db, "contentDetails"),
                where("contentId", "==", contentId)
            );
            const contentDetailsSnap = await getDocs(contentDetailsQ);

            for (const detailDoc of contentDetailsSnap.docs) {
                const detailData = detailDoc.data();

                // Media dosyaları
                if (detailData.mediaUrl) {
                    if (contentData.type === "video") {
                        const existingVideoQ = query(
                            collection(db, UPLOADS_COLLECTION_NAME),
                            where("sourceId", "==", contentId),
                            where("source", "==", UPLOADS_CONTENT_VIDEO_SOURCE),
                            where("path", "==", detailData.mediaUrl)
                        );
                        const existingVideoSnap = await getDocs(existingVideoQ);
                        if (existingVideoSnap.empty) {
                            await createUploadCompletedRecord({
                                type: UPLOADS_CONTENT_VIDEO_TYPE,
                                source: UPLOADS_CONTENT_VIDEO_SOURCE,
                                sourceId: contentId,
                                path: detailData.mediaUrl,
                                userId: userId
                            });
                            videoCount++;
                            console.log(`[UPLOAD][VIDEO MEDIA] contentId=${contentId} path=${detailData.mediaUrl}`);
                        }
                    } else if (contentData.type === "podcast") {
                        const existingPodcastQ = query(
                            collection(db, UPLOADS_COLLECTION_NAME),
                            where("sourceId", "==", contentId),
                            where("source", "==", UPLOADS_CONTENT_PODCAST_SOURCE),
                            where("path", "==", detailData.mediaUrl)
                        );
                        const existingPodcastSnap = await getDocs(existingPodcastQ);
                        if (existingPodcastSnap.empty) {
                            await createUploadCompletedRecord({
                                type: UPLOADS_CONTENT_PODCAST_TYPE,
                                source: UPLOADS_CONTENT_PODCAST_SOURCE,
                                sourceId: contentId,
                                path: detailData.mediaUrl,
                                userId: userId
                            });
                            audioCount++;

                            console.log(`[UPLOAD][PODCAST MEDIA] contentId=${contentId} path=${detailData.mediaUrl}`);
                        }
                    }
                }

                // Editor image
                if (detailData.description) {
                    const matches = [
                        ...detailData.description.matchAll(
                            new RegExp(`<img.*?src="(?:.*\\/)?${EDITOR_IMAGE_BASE_DIRECTORY}\\/([^"]+)".*?>`, "g")
                        ),
                    ];

                    for (const [_, src] of matches) {
                        const editorImagesPath = `${IMAGE_BASE_DIRECTORY}/${EDITOR_IMAGE_BASE_DIRECTORY}/${src}`;
                        const existingEditorQ = query(
                            collection(db, UPLOADS_COLLECTION_NAME),
                            where("sourceId", "==", contentId),
                            where("source", "==", UPLOADS_CONTENT_EDITOR_SOURCE),
                            where("path", "==", editorImagesPath)
                        );
                        const existingEditorSnap = await getDocs(existingEditorQ);

                        if (existingEditorSnap.empty) {

                            await createUploadCompletedRecord({
                                type: UPLOADS_IMAGE_TYPE,
                                source: UPLOADS_CONTENT_EDITOR_SOURCE,
                                sourceId: contentId,
                                path: editorImagesPath,
                                userId: userId
                            })
                            editorImageCount++;
                            console.log(`Editor image upload added for content ${contentId} editor_image: ${editorImagesPath}`);
                        }
                    }
                }
            }
        }

        console.log("All missing uploads created.");
        console.log(`Processed ${contentsSnap.size} contents.`);
        console.log(`Created => Cover: ${coverImageCount}, Video: ${videoCount}, Podcast: ${audioCount}, Editor: ${editorImageCount}`);
    } catch (err) {
        console.error("Error creating missing uploads: ", err);
    }
}

async function createMissingCategoryUploads() {
    try {
        const categoriesSnap = await getDocs(collection(db, "categories"));
        let iconCount = 0;

        for (const categoryDoc of categoriesSnap.docs) {
            const categoryData = categoryDoc.data();
            const categoryId = categoryDoc.id;
            const userId = categoryData.createdBy || null;

            if (categoryData.url) {
                const iconPath = `${IMAGE_BASE_DIRECTORY}/${categoryData.url}`;

                const existingQ = query(
                    collection(db, UPLOADS_COLLECTION_NAME),
                    where("sourceId", "==", categoryId),
                    where("source", "==", UPLOADS_CATEGORY_SOURCE),
                    where("path", "==", iconPath)
                );
                const existingSnap = await getDocs(existingQ);

                if (existingSnap.empty) {
                    await createUploadCompletedRecord({
                        type: UPLOADS_IMAGE_TYPE,
                        source: UPLOADS_CATEGORY_SOURCE,
                        sourceId: categoryId,
                        path: iconPath,
                        userId
                    });
                    iconCount++;
                    console.log(`[UPLOAD][CATEGORY_ICON] categoryId=${categoryId} path=${iconPath}`);
                }
            }
        }

        console.log(`Processed ${categoriesSnap.size} categories. Created Icons: ${iconCount}`);
    } catch (err) {
        console.error("Error creating category uploads: ", err);
    }
}


async function createMissingOnboardingUploads() {
    try {
        const onboardingSnap = await getDocs(collection(db, "onBoarding"));
        let onboardingCount = 0;

        for (const onboardingDoc of onboardingSnap.docs) {
            const onboardingData = onboardingDoc.data();
            const onboardingId = onboardingDoc.id;
            const userId = onboardingData.createdBy || null;

            if (onboardingData.imageUrl) {
                const onboardingPath = `${IMAGE_BASE_DIRECTORY}/${onboardingData.imageUrl}`;

                const existingQ = query(
                    collection(db, UPLOADS_COLLECTION_NAME),
                    where("sourceId", "==", onboardingId),
                    where("source", "==", UPLOADS_ONBOARDING_SOURCE),
                    where("path", "==", onboardingPath)
                );
                const existingSnap = await getDocs(existingQ);

                if (existingSnap.empty) {
                    await createUploadCompletedRecord({
                        type: UPLOADS_IMAGE_TYPE,
                        source: UPLOADS_ONBOARDING_SOURCE,
                        sourceId: onboardingId,
                        path: onboardingPath,
                        userId
                    });
                    onboardingCount++;
                    console.log(`[UPLOAD][ONBOARDING_IMAGE] onboardingId=${onboardingId} path=${onboardingPath}`);
                }
            }
        }

        console.log(`Processed ${onboardingSnap.size} onboarding docs. Created Images: ${onboardingCount}`);
    } catch (err) {
        console.error("Error creating onboarding uploads: ", err);
    }
}



// Eğer Firebase Function olarak deploy etmek istersen
export const backfillUploads = async () => {
    // await createMissingUploads();
    // await createMissingCategoryUploads();
    // await createMissingOnboardingUploads();
};